import { CONTACT_TYPE } from '@/constants/contactConstants';
import { AGENT_STATE } from '@/constants/agent/constants';
import store from '@/store';

export default class EcsContact {
  constructor(data) {
    Object.assign(this, structuredClone(data));
  }

  get contactType() {
    return CONTACT_TYPE.unknown;
  }

  get isFavorite() {
    if (!this.id) {
      return false;
    }

    const group = this.isInternalContact ? 'internal' : 'external';
    if (
      store.getters['CONTACTS/getFavoriteContacts'].favorites &&
      store.getters['CONTACTS/getFavoriteContacts'].favorites.length
    ) {
      return store.getters['CONTACTS/getFavoriteContacts'].favorites.some(favorite => favorite.id === this.id);
    } else if (store.getters['CONTACTS/getFavoriteContacts'][group]) {
      return store.getters['CONTACTS/getFavoriteContacts'][group].some(favoriteId => favoriteId === this.id);
    }

    return false;
  }

  get isInternalContact() {
    return false;
  }

  get isRinging() {
    return this.state && this.state.id === AGENT_STATE.offered;
  }

  get phones() {
    return [];
  }

  get mobiles() {
    return [];
  }

  get emails() {
    if (!this.email) {
      return [];
    }

    return [
      {
        description: 'E-mail',
        value: this.email
      }
    ];
  }

  get isChatEnabled() {
    return false;
  }

  get isEmailEnabled() {
    return this.emails && this.emails.length;
  }

  get isInteractionEnabled() {
    return this.isChatEnabled || this.isEmailEnabled;
  }
}
